import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  padding: 0 50px;
`;

export const Top = styled.div`
  padding: 50px 50px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
`;

export const Item = styled.div`
  width: 185px;
  height: 82px;
  padding: 5px;
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const Name = styled.div`
  color: #1a98f1;
  cursor: pointer;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`;
